import { inject, Pipe, PipeTransform } from '@angular/core';
import { AbstractTransport } from 'models/abstract-transport.model';
import { TransportConstraintsService } from '../../services/transport-constraints.service';

@Pipe({
  name: 'transportConstraints',
  standalone: true,
})
export class TransportConstraintsPipe implements PipeTransform {
  readonly #transportConstraintsService = inject(TransportConstraintsService);

  transform(value: AbstractTransport, options: { pickup?: boolean; delivery?: boolean; inline?: boolean }): string {
    return this.#transportConstraintsService.formatConstraints(value, options);
  }
}
